const List = () => import("~/components/Views/Prova/CorrigirRedacao/List");
const Form = () => import("~/components/Views/Prova/CorrigirRedacao/Form");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Gerenciamento", link: "" }
];

export const minhasRedacoes = [
  {
    path: "gerenciamento/minhas-redacoes",
    component: List,
    name: "Minhas Redações",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/corrigir-redacao/:aplicacaoProvaId",
    component: Form,
    name: "Correção de Redação",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/corrigir-redacao/:aplicacaoProvaId/:alunoId",
    component: Form,
    name: "Correção de Redação",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/minhasRedacoes.js